import { Shortcut, Node_Type } from 'ricos-types';
import { HEADER_BLOCK } from 'wix-rich-content-common';
import { createHeadingsPlugin } from './createHeadingsPlugin.js';
import { DEFAULTS } from './defaults.js';
import { ModalsMap } from './modals.js';
import { HEADINGS_DROPDOWN_TYPE } from './types.js';
import { getTextButtons } from './getTextButtons.js';
import './toolbar/createToolbar.js';
import 'react';
import 'wix-rich-content-editor-common';
import './toolbar/HeadingButton.js';
import './constants.js';
import 'react-modal';
import './HeadingPanel-e286797a.js';
import 'prop-types';
import 'classnames';
import 'wix-rich-content-plugin-commons';
import 'wix-rich-content-toolbars-v3/libs/resolvers-ids';
import 'wix-rich-content-toolbars-modals/libs/getCurrentHeadingIcon';
import './HeadingsPanelComponent.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const headerBlockByLevel = [
  HEADER_BLOCK.ONE,
  HEADER_BLOCK.TWO,
  HEADER_BLOCK.THREE,
  HEADER_BLOCK.FOUR,
  HEADER_BLOCK.FIVE,
  HEADER_BLOCK.SIX
];
const getShortcut = (level) => Shortcut({
  name: `${Node_Type.HEADING}.${level}`,
  description: `ShortcutsSheet_Formatting_Heading${level}`,
  keys: { macOs: `Meta+Alt+${level}`, windows: `Ctrl+Alt+${level}` },
  command(editorCommands) {
    editorCommands.setBlockType(headerBlockByLevel[level - 1]);
  },
  group: "ShortcutsSheet_Section_Formatting",
  enabled: true
});
const pluginHeadings = (config) => {
  return {
    config: __spreadValues(__spreadValues({}, DEFAULTS.config), config),
    type: HEADINGS_DROPDOWN_TYPE,
    createPlugin: createHeadingsPlugin,
    ModalsMap,
    shortcuts: [1, 2, 3, 4, 5, 6].map(getShortcut),
    textButtons: getTextButtons(config)
  };
};

export { pluginHeadings };
//# sourceMappingURL=editor.js.map
